export default __webpack_public_path__ + "static/media/subFrame2.d9e201ce.png";